export default __webpack_public_path__ + "static/media/csv.8ea0dd70.svg";